"use strict";

exports.__esModule = true;
exports.translateLabel = void 0;
var _hasPath2 = _interopRequireDefault(require("ramda/src/hasPath"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var translateLabel = exports.translateLabel = function translateLabel(label, translate) {
  if (label && (0, _hasPath2["default"])(["props", "id"], label) && (0, _hasPath2["default"])(["props", "defaultMessage"], label)) {
    return translate(label.props.id, label.props.defaultMessage);
  } else {
    return label;
  }
};